import { Checkbox, Col, Collapse, Radio } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import moment from 'moment';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const PatientDetails: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
}> = ({ rxConfig, saveRxConfigInState }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-burgandy-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="14"
                            width="14"
                            fill="white"
                            viewBox="0 0 448 512"
                        >
                            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">Patient Details</div>} key="1">
                <p className="mr-16 space-y-2">
                    <span className="font-700">Primary Patient Details</span>

                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    patient_details_format:
                                        rxConfig?.patient_details_format ===
                                        'name-age-slash-gender-number'
                                            ? ''
                                            : 'name-age-slash-gender-number',
                                });
                            }}
                        >
                            <span>Show labels for basic details</span>
                            <Checkbox
                                checked={
                                    rxConfig?.patient_details_format ===
                                    'name-age-slash-gender-number'
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    patient_details_in_uppercase: !rxConfig?.patient_details_in_uppercase,
                                });
                            }}
                        >
                            <span>Make patient detail labels uppercase</span>
                            <Checkbox checked={rxConfig?.patient_details_in_uppercase}></Checkbox>
                        </p>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Patient Name Color</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.patient_details_patient_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        patient_details_patient_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            patient_details_patient_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <span className="font-700">Secondary Patient Details</span>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    patient_form_data_format:
                                        rxConfig?.patient_form_data_format ===
                                        'pipe-seperated-without-key'
                                            ? ''
                                            : 'pipe-seperated-without-key',
                                });
                            }}
                        >
                            <span>Hide patient detail labels</span>
                            <Checkbox
                                checked={
                                    rxConfig?.patient_form_data_format ===
                                    'pipe-seperated-without-key'
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    patient_form_data_in_unbold: !rxConfig?.patient_form_data_in_unbold,
                                });
                            }}
                        >
                            <span>Make patient detail labels bold</span>
                            <Checkbox checked={!rxConfig?.patient_form_data_in_unbold}></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    patient_form_below_border: !rxConfig?.patient_form_below_border,
                                });
                            }}
                        >
                            <span>Show border below patient detail</span>
                            <Checkbox checked={rxConfig?.patient_form_below_border}></Checkbox>
                        </p>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Secondary Patient Data label</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.patient_details_form_data_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        patient_details_form_data_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            patient_details_form_data_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Secondary Patient Data Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={
                                    rxConfig?.patient_details_form_data_properties_color ||
                                    '#000000'
                                }
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        patient_details_form_data_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            patient_details_form_data_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>

                    <div className="border-b border-darwin-neutral-200 mx-8"></div>

                    <span className="font-700">Date</span>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    date_in_unbold: !rxConfig?.date_in_unbold,
                                });
                            }}
                        >
                            <span>Make the date bold</span>
                            <Checkbox checked={!rxConfig?.date_in_unbold}></Checkbox>
                        </p>
                    </div>
                    <div>
                        <div className="flex items-center justify-between">
                            <div>Data Colour</div>{' '}
                            <div className="flex space-x-12">
                                <input
                                    type="color"
                                    id="head"
                                    name="head"
                                    value={rxConfig?.patient_details_date_color || '#000000'}
                                    onChange={(e) => {
                                        saveRxConfigInState({
                                            patient_details_date_color: e.target.value,
                                        });
                                    }}
                                    className="circular-color-input"
                                />

                                <AntTooltip content="Reset">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                patient_details_date_color: '',
                                            });
                                        }}
                                    >
                                        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                    </svg>
                                </AntTooltip>
                            </div>
                        </div>
                    </div>

                    <div className="pl-8">
                        <span className="font-700 text-13">Format</span>

                        <Radio.Group
                            onChange={(e) => {
                                saveRxConfigInState({
                                    date_and_time: e?.target?.value || '',
                                });
                            }}
                            value={rxConfig?.date_and_time || 'date-time'}
                        >
                            <Col>
                                <Radio value={'date'}>
                                    Only Date ({moment().utcOffset('+05:30').format('DD/MM/YYYY')})
                                </Radio>
                            </Col>
                            <Col>
                                <Radio value={'date-time'}>
                                    Date & Time (
                                    {moment().utcOffset('+05:30').format('DD/MM/YYYY, HH:mmA')})
                                </Radio>
                            </Col>
                            <Col>
                                <Radio value={'day-month-date-year-time'}>
                                    Extended Date & Time (
                                    {moment()
                                        .utcOffset('+05:30')
                                        .format('dddd, MMMM D, YYYY h:mm A')}
                                    )
                                </Radio>{' '}
                            </Col>
                        </Radio.Group>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default PatientDetails;
